export default __webpack_public_path__ + "static/media/versus-game.50b717b3.svg";